import { render, staticRenderFns } from "./historico-acreditaciones.vue?vue&type=template&id=6ae34315&"
import script from "./historico-acreditaciones.component.ts?vue&type=script&lang=ts&"
export * from "./historico-acreditaciones.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports